export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14260.4ba1ae9c.jpg";